"use strict";

exports.__esModule = true;
exports.default = void 0;
var _tokens = require("../../styles/tokens");
// These are CSS variables from react-day-picker css
// Original CSS: https://github.com/gpbl/react-day-picker/blob/v8.0.7/packages/react-day-picker/src/style.css
var rdpCellSize = '2.75rem'; // 44px
var hedtechDaySize = '2rem'; // 32px
// const rdpAccentColor = '#0000ff';
// const rdpBackgroundColor = '#e7edff';
/* Switch to dark colors for dark themes */
// const rdpAccentColorDark = '#3003e1';        // NOT USED FROM RDP
// const rdpBackgroundColorDark = '#180270';    // NOT USED FROM RDP
// /* Outline border for focused elements */
// const rdpOutline = `2px solid ${rdpAccentColor}`;
/* Outline border for focused and selected elements */
// const rdpOutlineSelected = '2px solid rgba(0, 0, 0, 0.75)';

var styles = function styles(theme) {
  return {
    // These styles are extending the original styles from react-day-picker@8.0.7
    // The root class is designed to be able to support all DatePicker styles, as well as
    // shared styles for other date selecting components (such as DateRangePicker)
    root: {
      width: 'fit-content',
      backgroundColor: theme.palette.grey[100],
      border: _tokens.borderWidthThin + " solid " + theme.palette.grey[400],
      borderRadius: _tokens.borderRadiusMedium,
      '& .rdp': {
        margin: '.75rem .5rem',
        fontFamily: _tokens.fontFamilyDefault
      },
      '& .rdp-vhidden': {
        boxSizing: 'border-box',
        padding: '0 !important',
        margin: '0',
        background: 'transparent',
        border: '0 !important',
        mozAppearance: 'none',
        webkitAppearance: 'none',
        appearance: 'none',
        position: 'absolute !important',
        top: '0',
        width: '1px !important',
        height: '1px !important',
        fallbacks: [{
          border: '0',
          padding: '0'
        }],
        overflow: 'hidden !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important'
      },
      '& .rdp-button_reset': {
        appearance: 'none',
        position: 'relative',
        margin: '0',
        padding: '0',
        cursor: 'default',
        color: 'inherit',
        outline: 'none',
        background: 'none',
        font: 'inherit',
        mozAppearance: 'none',
        webkitAppearance: 'none'
      },
      '& .rdp-button': {
        border: 'none',
        color: theme.palette.grey[600],
        outline: _tokens.borderWidthThick + " solid transparent"
      },
      '& .rdp-nav .rdp-button[disabled]': {
        // Previous and Next Buttons in navigation
        color: theme.palette.grey[400],
        fill: theme.palette.grey[400],
        backgroundColor: theme.palette.grey[250]
      },
      '& .rdp-button[disabled]': {
        // Disabled days
        pointerEvents: 'none',
        '& .hedtech-day': {
          color: theme.palette.action.disabled,
          backgroundColor: theme.palette.grey[250]
        }
      },
      '& .rdp-button:not([disabled])': {
        cursor: 'pointer'
      },
      '& .rdp-button:focus, .rdp-button:active': {
        // Focus and Active states for all buttons
        // including Day element buttons
        color: 'inherit',
        outline: _tokens.borderWidthThick + " solid " + _tokens.colorBorderGlobalFocus
      },
      '& .rdp-button:hover:not([disabled])': {
        '& .hedtech-day': {
          backgroundColor: theme.palette.grey[250]
        }
      },
      '& .rdp-months': {
        display: 'flex'
      },
      '& .rdp-month': {
        margin: '0 1em'
      },
      '& .rdp-month:first-child': {
        marginLeft: '0'
      },
      '& .rdp-month:last-child': {
        marginRight: '0'
      },
      '& .rdp-table': {
        margin: '0',
        maxWidth: "calc(" + rdpCellSize + " * 7)",
        borderCollapse: 'collapse'
      },
      '& .rdp-with_weeknumber .rdp-table': {
        maxWidth: "calc(" + rdpCellSize + " * 8)",
        borderCollapse: 'collapse'
      },
      /**
       * Caption is the headerbar of the DatePicker
       * Contains the current month and year, previous/next buttons or the month/year dropdowns
       */
      '& .rdp-caption': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0',
        textAlign: 'left',
        position: 'relative'
      },
      '& .rdp-multiple_months .rdp-caption': {
        position: 'relative',
        display: 'block',
        textAlign: 'center'
      },
      // Dropdown Caption container
      '& .rdp-caption_dropdowns': {
        position: 'relative',
        display: 'inline-flex',
        justifyContent: 'space-between',
        width: '100%'
      },
      '& .rdp-caption_label': {
        position: 'relative',
        zIndex: 1,
        display: 'inline-flex',
        alignItems: 'center',
        margin: 0,
        padding: "0 " + _tokens.spacing20,
        whiteSpace: 'nowrap',
        color: 'currentColor',
        fallbacks: [{
          border: '0'
        }],
        fontFamily: 'inherit',
        fontSize: _tokens.fontSizeLarge,
        fontWeight: 'bold',
        lineHeight: 1.5,
        '& svg': {
          marginLeft: '.75rem',
          fill: theme.palette.grey[500]
        }
      },
      '& .rdp-nav': {
        // the div wrapping the prev/next month buttons
        // custom way to display
        position: 'absolute',
        width: '100%',
        justifyContent: 'space-between',
        display: 'inline-flex',
        whiteSpace: 'nowrap'
      },
      '& .rdp-multiple_months .rdp-caption_start .rdp-nav': {
        display: 'block',
        // restore from single month view
        width: 'auto',
        // restore from single month view
        justifyContent: 'initial',
        position: 'absolute',
        top: '50%',
        left: '0',
        transform: 'translateY(-50%)'
      },
      '& .rdp-multiple_months .rdp-caption_end .rdp-nav': {
        display: 'block',
        // restore from single month view
        width: 'auto',
        // restore from single month view
        justifyContent: 'initial',
        position: 'absolute',
        top: '50%',
        right: '0',
        transform: 'translateY(-50%)'
      },
      '& .rdp-nav_button': {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: hedtechDaySize,
        height: hedtechDaySize,
        padding: _tokens.spacing20,
        margin: _tokens.spacing20,
        borderRadius: _tokens.borderRadiusSmall,
        '&:hover': {
          fill: theme.palette.ctaColor.hover
        }
      },
      '& .rdp-dropdown_year, .rdp-dropdown_month': {
        // parent div to select element
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center'
      },
      '& .rdp-dropdown': {
        // HTML select element
        appearance: 'none',
        position: 'absolute',
        zIndex: '2',
        top: '0',
        bottom: '0',
        left: '0',
        width: '100%',
        margin: '0',
        padding: _tokens.spacing30,
        cursor: 'inherit',
        opacity: '0',
        border: 'none',
        backgroundColor: 'transparent',
        fontFamily: 'inherit',
        fontSize: _tokens.fontSizeLarge,
        lineHeight: 1.5
      },
      '& .rdp-dropdown[disabled]': {
        opacity: 'unset',
        color: 'unset'
      },
      '& .rdp-dropdown:focus:not([disabled]) + .rdp-caption_label, .rdp-dropdown:active:not([disabled]) + .rdp-caption_label': {
        borderRadius: _tokens.borderRadiusSmall,
        backgroundColor: theme.palette.grey[250],
        outline: _tokens.borderWidthThick + " solid " + _tokens.colorBorderGlobalFocus
      },
      '& .rdp-dropdown_icon': {
        margin: '0 0 0 5px'
      },
      /**
       * The thead element of the table of days
       */
      '& .rdp-head': {
        border: '0'
      },
      '& .rdp-head_row, .rdp-row': {
        height: '100%'
      },
      '& .rdp-head_cell': {
        // Days of the week thead element
        verticalAlign: 'middle',
        textTransform: 'uppercase',
        fontSize: _tokens.fontSizeDefault,
        fontWeight: _tokens.fontWeightNormal,
        textAlign: 'center',
        height: rdpCellSize,
        color: theme.palette.grey[500],
        fallbacks: [{
          height: '100%'
        }],
        padding: '0'
      },
      '& .rdp-tbody': {
        border: '0'
      },
      '& .rdp-tfoot': {
        margin: '0.5em'
      },
      '& .rdp-cell': {
        // The actual days
        width: rdpCellSize,
        height: rdpCellSize,
        color: theme.palette.grey[600],
        fallbacks: [{
          height: '100%'
        }],
        padding: '0',
        textAlign: 'center'
      },
      '& .rdp-weeknumber': {
        fontSize: '0.75em'
      },
      '& .rdp-weeknumber, .rdp-day': {
        // Button element for the Day element
        display: 'flex',
        overflow: 'hidden',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        width: rdpCellSize,
        maxWidth: rdpCellSize,
        height: rdpCellSize,
        margin: 'auto',
        borderRadius: 2,
        '& .hedtech-day': {
          // Custom Day wrapper div element for custom circle
          display: 'flex',
          overflow: 'hidden',
          alignItems: 'center',
          justifyContent: 'center',
          boxSizing: 'border-box',
          width: hedtechDaySize,
          maxWidth: hedtechDaySize,
          height: hedtechDaySize,
          margin: 'auto',
          borderRadius: _tokens.borderRadiusCircle,
          fontSize: _tokens.fontSizeDefault
        }
      },
      '& .rdp-day_outside': {
        // Outside current month Day Cell
        color: theme.palette.grey[500]
      },
      '& .rdp-day_range_middle.rdp-day_selected:not([disabled]), & .rdp-day_today.rdp-day_selected.rdp-day_range_middle:not(.rdp-day_outside)': {
        '& .hedtech-day': {
          backgroundColor: theme.palette.ctaColor.tint,
          color: theme.palette.grey[600],
          borderRadius: 0,
          width: rdpCellSize,
          maxWidth: rdpCellSize
        },
        '&:focus': {
          zIndex: 2,
          // this is so the focus state is shown over the index of the start and end range dates
          borderRadius: 2,
          '& .hedtech-day': {
            backgroundColor: theme.palette.grey[250],
            color: theme.palette.grey[600],
            borderRadius: '100%',
            width: hedtechDaySize,
            maxWidth: hedtechDaySize
          }
        },
        '&:active': {
          '& .hedtech-day': {
            color: theme.palette.grey[600]
          }
        },
        '&:hover': {
          '& .hedtech-day': {
            backgroundColor: theme.palette.grey[250],
            color: theme.palette.grey[600]
          }
        }
      },
      '& .rdp-day_selected:not([disabled]), .rdp-day_selected:focus:not([disabled]), .rdp-day_selected:active:not([disabled]), .rdp-day_selected:hover:not([disabled])': {
        // Selected Day Cell
        '&:hover': {
          '& .hedtech-day': {
            backgroundColor: theme.palette.ctaColor.hover,
            color: theme.palette.grey[100],
            borderRadius: '100%',
            width: hedtechDaySize,
            maxWidth: hedtechDaySize
          }
        },
        '& .hedtech-day': {
          fontWeight: _tokens.fontWeightBold,
          backgroundColor: theme.palette.ctaColor.base,
          color: theme.palette.grey[100]
        }
      },
      '& .rdp-day_today.rdp-day_selected:not(.rdp-day_outside)': {
        '&:hover': {
          '& .hedtech-day': {
            backgroundColor: theme.palette.ctaColor.hover
          }
        },
        '& .hedtech-day': {
          fontWeight: _tokens.fontWeightBold,
          backgroundColor: theme.palette.ctaColor.base,
          color: theme.palette.grey[100]
        }
      },
      '& .rdp-day_selected:focus:not([disabled])': {
        // backgroundColor: theme.palette.ctaColor.hover,
        // border: rdpOutlineSelected,
      },
      // Date Range Selection related styles
      '& .rdp:not([dir="rtl"]) .rdp-day_range_start:not(.rdp-day_range_end)': {
        borderTopRightRadius: '0',
        borderBottomRightRadius: '0',
        position: 'relative',
        zIndex: 1,
        '&:before': {
          right: 0,
          width: "calc(" + rdpCellSize + " * .5)",
          // ~ half of parent div
          height: hedtechDaySize,
          content: '""',
          display: 'block',
          position: 'absolute',
          // this creates a new stacking z-index
          zIndex: -1,
          backgroundColor: theme.palette.ctaColor.tint
        }
      },
      '& .rdp:not([dir="rtl"]) .rdp-day_range_end:not(.rdp-day_range_start)': {
        borderTopLeftRadius: '0',
        borderBottomLeftRadius: '0',
        position: 'relative',
        zIndex: 1,
        '&:before': {
          left: 0,
          width: "calc(" + rdpCellSize + " * .5)",
          // ~ half of parent div
          height: hedtechDaySize,
          content: '""',
          display: 'block',
          position: 'absolute',
          // this creates a new stacking z-index
          zIndex: -1,
          backgroundColor: theme.palette.ctaColor.tint
        }
      },
      '& .rdp[dir="rtl"] .rdp-day_range_start:not(.rdp-day_range_end)': {
        borderTopLeftRadius: '0',
        borderBottomLeftRadius: '0',
        position: 'relative',
        zIndex: 1,
        '&:before': {
          right: 0,
          width: "calc(" + rdpCellSize + " * .5)",
          // ~ half of parent div
          height: hedtechDaySize,
          content: '""',
          display: 'block',
          position: 'absolute',
          // this creates a new stacking z-index
          zIndex: -1,
          backgroundColor: theme.palette.ctaColor.tint
        }
      },
      '& .rdp[dir="rtl"] .rdp-day_range_end:not(.rdp-day_range_start)': {
        borderTopRightRadius: '0',
        borderBottomRightRadius: '0',
        position: 'relative',
        zIndex: 1,
        '&:before': {
          left: 0,
          width: "calc(" + rdpCellSize + " * .5)",
          // ~ half of parent div
          height: hedtechDaySize,
          content: '""',
          display: 'block',
          position: 'absolute',
          // this creates a new stacking z-index
          zIndex: -1,
          backgroundColor: theme.palette.ctaColor.tint
        }
      },
      // '& .rdp-day_range_end.rdp-day_range_start': {
      //     borderRadius: '100%'
      // },
      '& .rdp-day_range_middle': {
        borderRadius: '0',
        '& .hedtech-day': {
          fontWeight: _tokens.fontWeightNormal + " !important"
        }
      }
    },
    highlightToday: {
      // Today Day Cell, but not if disabled or outside month
      '& .rdp-day_today:not(.rdp-day_outside).rdp-day_today:not(.rdp-day_selected)': {
        fontWeight: _tokens.fontWeightBold,
        backgroundColor: theme.palette.ctaColor.tint,
        color: theme.palette.ctaColor.base
      }
    }
  };
};
var _default = exports.default = styles;